export const environment = {
  production: false,
  apiBaseUrl: '/api',
  auth0Domain: 'terega.eu.auth0.com',
  auth0ClientId: 'TCxIPGt70sbTL45zpcCxM8fGIajIK2bL',
  auth0Audience: ''
};
